import { render, staticRenderFns } from "./PriceLimits.vue?vue&type=template&id=2382bb6c&"
import script from "./PriceLimits.vue?vue&type=script&lang=js&"
export * from "./PriceLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports